import { MediaType } from "constants/enums";
import { DirectUploadMedia } from "libs/directUpload";
import lodashFilter from "lodash/filter";
import lodashMap from "lodash/map";

import { ProductVideoVariant } from "../constants/enums";

export const getMediaFilesIdsByProductVideoVariant = (
  mediaFiles: DirectUploadMedia[],
  productVideoVariant: ProductVideoVariant
) => {
  const filteredMediaFiles =
    productVideoVariant === ProductVideoVariant.FOR_EACH_VIDEO
      ? mediaFiles
      : lodashFilter(mediaFiles, { mediaType: MediaType.IMAGE });

  return lodashMap(filteredMediaFiles, "id");
};
